import { Table } from 'antd'
import React from 'react'
import { useAntdColumnResize } from 'react-antd-column-resize'

const ColumnResizeTable = ({ columns, dataSource }) => {
  const { resizableColumns, components, tableWidth } = useAntdColumnResize(() => {
    return { columns, minWidth: 1 }
  }, [columns])

  return <Table columns={resizableColumns} dataSource={dataSource} components={components} size="small" scroll={{ x: tableWidth }} pagination={false} />
}

export default ColumnResizeTable
